import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-slate-950 py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-249" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-250" data-mp="3fxb2ghka7obn">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-251" data-mp="3azjcvu740eam">
          Testimonials from educators using this teacher ready
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-252" data-mp="31zd3ajej7ygq">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-slate-400/20 bg-slate-800 p-6 shadow-lg shadow-black/20" data-id="element-253" data-mp="2x1kzos4iynwp" data-mpi={index}>
              <div className="flex text-slate-200" aria-label="5 out of 5 stars" data-id="element-254" data-mp="h816hkw3kaiw">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-255" data-mp="78a99bg5jhf4" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-slate-200" data-id="element-256" data-mp="c7myg2uhx0kv">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-slate-400/15 pt-4" data-id="element-257" data-mp="zwy2pub21d3r">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg metal text-sm font-extrabold text-slate-950" data-id="element-258" data-mp="14u7qz6mpjiq0">
                  {initials}
                </span>
                <span data-id="element-259" data-mp="v4eoqw8ggfyf">
                  <b className="block text-sm text-white" data-id="element-260" data-mp="v3wgt2cfkdao">{name}</b>
                  <small className="text-xs text-slate-400" data-id="element-261" data-mp="1iu8yv61e3qez">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}